<template>
<!--  :class="{ vanish: !withinRange }" think about including this in div-->
  <div>
      <v-card
        class="mx-auto"
        color="grey lighten-4"
        max-width="600"
      >
<!--         since an image covers everythin, without an image from the backend, it would not show-->
        <v-img
          v-if="productInfo.images[0].original"
          class="white--text align-end"
          :aspect-ratio="16/9"
          height="200px"
          :src="placeHolderSrc"
          :alt="name"
        >
        <!-- here for the initial prod image -->
        <!-- productInfo.images[0].original ? productInfo.images[0].original:  -->
          <v-card-title>{{productInfo.product_class}}</v-card-title>
          <v-expand-transition>
            <div
              v-if="hover"
              class="d-flex transition-fast-in-fast-out white darken-2 v-card--reveal display-3 white--text"
              style="height: 100%;"
            >
              <v-btn v-if="hover" @click="goToProductPage" class="" outlined>VIEW</v-btn>
            </div>

          </v-expand-transition>
        </v-img>
        <v-card-text class="text--primary">
          <div><a href="/product" style="text-decoration: none">{{name}}</a></div>
          <div>Ksh{{this.totalPrice.incl_tax}}</div>
        </v-card-text>
      </v-card>

  </div>
</template>

<script>
import axios from 'axios'
export default {
name: "ProductCard",
  props: ['url','name', 'type', 'image', 'price' , 'hover', 'priceRange'],
  data: () =>  ({
    productInfo:{
      product_class: '',
      images: ['','']
    },
    totalPrice: {incl_tax: 0}
  }),
  created() {
  axios.get(this.url).then(res =>{
    this.productInfo = res.data
    this.getProductPrice(res.data)
  }).catch(error =>{
    console.log(error)
  })
  },
  computed: {
    withinRange () {
      // console.log('Price range:', this.priceRange, this.totalPrice)
      // console.log('actual Price:', this.totalPrice.incl_tax)
      // console.log('Within Range is:',this.price >= this.priceRange[0] && this.price <= this.priceRange[1])
      return this.price >= this.priceRange[0] && this.price <= this.priceRange[1]
    },
    placeHolderSrc () {
      const placeHolderSrcChoices = [ 
        "https://images.unsplash.com/photo-1562157873-818bc0726f68?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8Y2xvdGhlc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
        "https://images.unsplash.com/photo-1542060748-10c28b62716f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Y2xvdGhlc3xlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
        "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGNsb3RoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
        "https://images.unsplash.com/photo-1537274942065-eda9d00a6293?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fGNsb3RoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
        "https://images.unsplash.com/photo-1544441893-675973e31985?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjJ8fGNsb3RoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
        "https://images.unsplash.com/photo-1479064555552-3ef4979f8908?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzR8fGNsb3RoZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
        ]
      const index = Math.floor(Math.random() * placeHolderSrcChoices.length);
      return placeHolderSrcChoices[index];
    }
  },
  methods: {
    getProductPrice(productInfo){
      axios.get(productInfo.price).then(res=>{
        this.totalPrice = res.data
        this.$emit('itemPrice', this.totalPrice)
      }).catch(error =>{
        console.log(error)
      })
    },
    goToProductPage(){
      // get the product ID and parse it into the url for fetch later
      const extraParamUrl = this.url.split('products/')[1].slice(0, -1)
      this.$router.push({ name: 'Product', params: { prodId: extraParamUrl } })
    }
  }
}
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}
  .vanish{
    width: 0;
    height: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductCard.vue